import React from 'react';
import { HeartIcon } from 'lucide-react';
const OurStory = () => {
  return <section id="our-story" className="bg-ivory py-20" data-id="element-122">
      <div className="section-container" data-id="element-123">
        <h2 className="section-heading" data-id="element-124">Our Love Story</h2>
        <div className="flex flex-col md:flex-row items-center gap-10 max-w-5xl mx-auto" data-id="element-125">
          <div className="md:w-1/2" data-id="element-126">
            <div className="relative" data-id="element-127">
              <img src="https://cdn.magicpatterns.com/uploads/8q58gwnYxRaoXwf3cW3Tm9/www.ayevbosaandabiodun.live.png" alt="Ayevbosa and Abiodun wedding invitation" className="w-full rounded-md shadow-lg" data-id="element-128" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-blush rounded-full flex items-center justify-center" data-id="element-129">
                <HeartIcon size={30} className="text-gold" data-id="element-130" />
              </div>
            </div>
          </div>
          <div className="md:w-1/2 mt-10 md:mt-0" data-id="element-131">
            <h3 className="font-serif text-2xl mb-4 text-gray-800" data-id="element-132">
              How We Met
            </h3>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-133">
              It was June 1, 2016, in a 200-level Agric Economics class when our
              story began. I needed to copy some notes, and Ayevbosa kindly lent
              me hers. From that moment, I was struck by how calm, beautiful,
              and witty she was. What started as a simple study partnership
              slowly blossomed into a deep friendship. Over the years, her
              kindness, love, and amazing spirit made me fall more in love with
              her. She has been a blessing and a gift from God to me, and I'm
              truly grateful for every moment of our journey together.
            </p>
            <h3 className="font-serif text-2xl mb-4 text-gray-800" data-id="element-134">
              The Proposal
            </h3>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-135">
              After years of building our love story, I knew it was time to ask
              the most important question of my life. I planned an intimate
              gathering, inviting our closest friends and family to share in
              this special moment. As Ayevbosa walked in, surrounded by the
              people who mean the world to us both, she was greeted by flowers,
              warm smiles, and an atmosphere filled with love. With everyone
              watching and my heart racing, I got down on one knee and asked her
              to be my wife. Her tears of joy and that beautiful "yes" marked
              the beginning of our forever.
            </p>
            <div className="text-center md:text-left" data-id="element-136">
              <span className="font-serif italic text-gold text-lg" data-id="element-137">
                "And so the adventure begins..."
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default OurStory;